import React, { useState } from 'react'
import { Button, Container, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import { grey } from '@material-ui/core/colors'
import HomeIcon from '@material-ui/icons/Home'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Logo from '../../assets/Ads Logo_LightMode.svg'
// import SignUpCard from "../../components/signup/SignUpCard"
// import AgencyStep1 from "../../components/signup/AgencyStep1"
import SignUpCardContainer from '../../components/signup/SignUpContainer'
import './Sign.css'

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      fontWeight: '800',
      textDecoration: 'none'
    }
  },
  button: {
    color: grey[100]
  },
  call: {
    '& > *': {
      marginTop: theme.spacing(4),
      fontWeight: '600'
    }
  }
}))

export default function SignPage() {
  const mobile = useMediaQuery('(max-width: 600px)')
  const classes = useStyles()
  const [count, setCount] = useState(0)
  return (
    <div className="signpage">
      <header>
        <Container className="header-container">
          <img className="logo" src={Logo} alt="logo" />
          {mobile ? (
            <div className={classes.root}>
              {count >= 1 ? (
                <Button
                  onClick={() => setCount(count - 1)}
                  color="secondary"
                  className={classes.button}
                  variant="contained"
                  disableElevation>
                  <ArrowBackIcon />
                </Button>
              ) : (
                <Button
                  component={Link}
                  to="/"
                  color="secondary"
                  className={classes.button}
                  variant="contained"
                  disableElevation>
                  <HomeIcon />
                </Button>
              )}
            </div>
          ) : (
            <div className={classes.root}>
              {count >= 1 ? (
                <Button
                  onClick={() => setCount(count - 1)}
                  color="secondary"
                  className={classes.button}
                  variant="contained"
                  disableElevation
                  startIcon={<ArrowBackIcon />}>
                  Back
                </Button>
              ) : (
                <Button
                  component={Link}
                  to="/"
                  color="secondary"
                  className={classes.button}
                  variant="contained"
                  startIcon={<HomeIcon />}
                  disableElevation>
                  Home
                </Button>
              )}
            </div>
          )}
        </Container>
      </header>
      <div className="logincard">
        {/* <SignUpCard /> */}
        <SignUpCardContainer count={count} setCount={setCount} />
      </div>
    </div>
  )
}
